import { Route, RouteConfig } from 'vue-router';
import { RiaUpgradeRoute } from 'types/ria';
import { riaUpgradeRouteOrder } from '@src/constants';

const getFlowStepIndex = (name: RiaUpgradeRoute): number => {
	return riaUpgradeRouteOrder.indexOf(name) + 1;
};

const metaConstructor = (route: Route): object => ({
	step: getFlowStepIndex(route.name as RiaUpgradeRoute)
});

/* eslint-disable @typescript-eslint/explicit-function-return-type */
const riaUpgradeRoutes: Array<RouteConfig> = [
	{
		path: `/account/ria-upgrade`,
		name: 'ria-upgrade',
		component: () => import(/* webpackChunkName: "ria-upgrade" */ '@views/account/ria-upgrade/ria-upgrade.vue'),
		redirect: { name: 'ria-upgrade-select-investment-plan' },
		children: [
			{
				path: 'select-investment-plan',
				name: 'ria-upgrade-select-investment-plan',
				meta: metaConstructor,
				component: () =>
					import(
						/* webpackChunkName: "ria-upgrade-select-investment-plan" */ '@views/account/ria-upgrade/ria-upgrade-select-investment-plan.vue'
					)
			},
			{
				path: 'agreements',
				name: 'ria-upgrade-agreements',
				meta: metaConstructor,
				component: () =>
					import(
						/* webpackChunkName: "ria-upgrade-agreements" */ '@views/account/ria-upgrade/ria-upgrade-agreements.vue'
					)
			},
			{
				path: 'success',
				name: 'ria-upgrade-success',
				meta: metaConstructor,
				component: () =>
					import(
						/* webpackChunkName: "ria-upgrade-success" */ '@views/account/ria-upgrade/ria-upgrade-success.vue'
					)
			}
		]
	}
];

export default riaUpgradeRoutes;
